import(/* webpackMode: "eager" */ "/home/coder/pubky-app-cards/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/coder/pubky-app-play/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/coder/pubky-app-cards/node_modules/next/font/google/target.css?{\"path\":\"src/components/molecules/ContainerRoot/ContainerRoot.tsx\",\"import\":\"Inter_Tight\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"interTight\"}");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/home/coder/pubky-app-play/src/components/atoms/Tooltip/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Fab"] */ "/home/coder/pubky-app-play/src/components/molecules/Fab/Fab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/coder/pubky-app-play/src/components/molecules/Toaster/Toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatorsManager"] */ "/home/coder/pubky-app-play/src/components/organisms/CoordinatorsManager/CoordinatorsManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogSignIn"] */ "/home/coder/pubky-app-play/src/components/organisms/DialogSignIn/DialogSignIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuestContextualBanner"] */ "/home/coder/pubky-app-play/src/components/organisms/GuestContextualBanner/GuestContextualBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/coder/pubky-app-play/src/components/organisms/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PulseConsentBanner"] */ "/home/coder/pubky-app-play/src/components/organisms/PulseConsent/PulseConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PwaManager"] */ "/home/coder/pubky-app-play/src/components/organisms/PwaManager/PwaManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatabaseProvider"] */ "/home/coder/pubky-app-play/src/providers/DatabaseProvider/DatabaseProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundaryProvider"] */ "/home/coder/pubky-app-play/src/providers/ErrorBoundaryProvider/ErrorBoundaryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorHandlerProvider"] */ "/home/coder/pubky-app-play/src/providers/GlobalErrorHandlerProvider/GlobalErrorHandlerProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteGuardProvider"] */ "/home/coder/pubky-app-play/src/providers/RouteGuardProvider/RouteGuardProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistrationProvider"] */ "/home/coder/pubky-app-play/src/providers/ServiceWorkerRegistrationProvider/ServiceWorkerRegistrationProvider.tsx");
